export const FILTER_VALUE_SEPARATOR = '^';
export const DURATION_FILTER_VALUE_SEPARATOR = ':';
export const RANGE_FILTER_SEPARATOR = '>';
export const FILTER_MATCH_TYPE_SEPARATOR = ':';
export const COMPANY_ID_FILTER_SEPARATOR = '::';
export const BULK_FILTER_VALUE_SEPARATOR = '::';

// Internal-only separators for the pinned-filters tag-signature cache.
// ASCII Unit / Record Separators — chosen because they can't appear in URL
// param values, so signatures can't collide for distinct content.
export const TAG_SIGNATURE_VALUE_SEPARATOR = '\x1f';
export const TAG_SIGNATURE_RECORD_SEPARATOR = '\x1e';
